import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "@faire/web--source/ui/hooks/useState";
import React from "react";
import styled from "styled-components";
import { setTimeoutIfPossible } from "@faire/retailer/lib/async-functions/setTimeoutIfPossible";
var AnimatedState;
(function(AnimatedState) {
    AnimatedState[AnimatedState["INITIALIZE"] = 0] = "INITIALIZE";
    AnimatedState[AnimatedState["MOUNTED"] = 1] = "MOUNTED";
    AnimatedState[AnimatedState["LOADED"] = 2] = "LOADED";
})(AnimatedState || (AnimatedState = {}));
export function animated(Comp) {
    return function(options) {
        var StyledComp = styled(Comp).withConfig({
            componentId: "sc-a0e09d0c-0"
        })([
            "transition:all 0.2s ease;",
            ";",
            ";",
            ";"
        ], options.initialStyle, function(param) {
            var state = param.state;
            return state >= AnimatedState.MOUNTED && options.mountedStyle;
        }, function(param) {
            var state = param.state;
            return state >= AnimatedState.LOADED && options.loadedStyle;
        });
        var AnimatedComponent = function(props) {
            var _useState = _sliced_to_array(useState(AnimatedState.INITIALIZE), 2), state = _useState[0], setState = _useState[1];
            React.useEffect(function() {
                setState(AnimatedState.MOUNTED);
            }, []);
            React.useEffect(function() {
                if (state === AnimatedState.MOUNTED) {
                    var _options_delay;
                    setTimeoutIfPossible(function() {
                        setState(AnimatedState.LOADED);
                    }, (_options_delay = options.delay) !== null && _options_delay !== void 0 ? _options_delay : 50);
                }
            }, [
                state
            ]);
            return /*#__PURE__*/ _jsx(StyledComp, _object_spread_props(_object_spread({}, props), {
                state: state
            }));
        };
        return AnimatedComponent;
    };
}
